import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
import { CONTACT_CONFIG } from '../config/contact';
import { ShieldCheck, Clock, FileCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-white pt-12 pb-16 md:pt-20 md:pb-24 overflow-hidden" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-68">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-69">
          {/* Copy Column */}
          <div className="flex flex-col gap-6 text-center md:text-left" data-id="element-70">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-800 text-sm font-semibold w-fit mx-auto md:mx-0" data-id="element-71">
              <ShieldCheck className="w-4 h-4" data-id="element-72" />
              <span data-id="element-73">Official Translations in Miami</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight leading-tight" data-id="element-74">
              Certified Translations{' '}
              <span className="text-blue-800" data-id="element-75">Accepted by USCIS</span> and
              Official Institutions
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto md:mx-0" data-id="element-76">
              Certification included, 100% legally valid. Delivered in{' '}
              <strong className="text-gray-900" data-id="element-77">
                {CONTACT_CONFIG.DELIVERY_TIME}
              </strong>
              . {CONTACT_CONFIG.GUARANTEE}.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4 items-center md:items-start justify-center md:justify-start" data-id="element-78">
              <WhatsAppButton size="lg" className="w-full sm:w-auto" data-id="element-79" />
              <a href="#proceso" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-lg text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors w-full sm:w-auto" data-id="element-80">
                See how it works
              </a>
            </div>

            <div className="flex items-center gap-6 mt-6 justify-center md:justify-start text-sm text-gray-500 font-medium" data-id="element-81">
              <div className="flex items-center gap-1.5" data-id="element-82">
                <FileCheck className="w-4 h-4 text-green-600" data-id="element-83" />
                <span data-id="element-84">Original signature</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-85">
                <Clock className="w-4 h-4 text-green-600" data-id="element-86" />
                <span data-id="element-87">Fast and secure</span>
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="relative hidden md:block" data-id="element-88">
            <div className="absolute inset-0 bg-blue-100 rounded-2xl transform translate-x-4 translate-y-4" data-id="element-89"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vc1w2tT48pAsyHBzux8erG/itranscorp.jpg" alt="Translation specialist holding a certified, sealed document" className="relative rounded-2xl shadow-xl object-cover h-[500px] w-full" data-id="element-90" />
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg flex items-center gap-4 border border-gray-100" data-id="element-91">
              <div className="bg-green-100 p-3 rounded-full" data-id="element-92">
                <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-93" />
              </div>
              <div data-id="element-94">
                <p className="text-sm text-gray-500 font-medium" data-id="element-95">Guarantee</p>
                <p className="font-bold text-gray-900" data-id="element-96">100% Accepted</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}